// Shared labels of the Draft Check screens.

// Only .docx and .pdf can be compared (a .doc must be saved as .docx first).
export const comparableFile = (name = '') => /\.(docx|pdf)$/i.test(name);

export const SEVERITY = {
  high: { label: 'High', cls: 'tw-bg-red-50 tw-text-red-700 tw-border-red-200' },
  medium: { label: 'Medium', cls: 'tw-bg-amber-50 tw-text-amber-700 tw-border-amber-200' },
  low: { label: 'Low', cls: 'tw-bg-yellow-50 tw-text-yellow-800 tw-border-yellow-200' },
  review: { label: 'To review', cls: 'tw-bg-sky-50 tw-text-sky-700 tw-border-sky-200' },
  none: { label: 'Fill-in / formatting', cls: 'tw-bg-slate-100 tw-text-slate-500 tw-border-slate-200' },
};
export const SEVERITY_ORDER = ['high', 'medium', 'low', 'review', 'none'];

export const CATEGORY = {
  substantive: 'Substantive change', wording: 'Wording', formatting: 'Formatting', fill_in: 'Template field filled in',
  unclassified: 'Not classified',
};

export const KIND = { insert: 'Added', delete: 'Removed', replace: 'Changed', hidden: 'Hidden text' };

export const RUNNING = ['queued', 'processing'];

export const errorOf = (e, fallback) => e?.response?.data?.error || fallback;
export const when = (value) => (value ? new Date(value).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '');
// The standard compared with: the file the user uploaded.
export const standardLabel = (t) => t?.name || '';
export const toReviewCount = (stats) => ['high', 'medium', 'low', 'review'].reduce((n, k) => n + (stats?.by_severity?.[k] || 0), 0);
